export enum DataPointSearchCategory {
  None = 0,
  Menu = 1 << 0,
  Basic = 1 << 1,
  Conditions = 1 << 2,
  Donations = 1 << 3,
  Miscellaneous = 1 << 4,
  Attributes = 1 << 5,
}
